import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

        {
            "Name": "Aiswarya T",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2022",
            "AreasofResearch": "Fractals",
            "GuideName": "Dr. Srijanani Anurag Prasad",
            "GuideLink": "/dr-srijanani-anurag-prasad",
            "Email": "ma22d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/Aiswarya T.jpg"
        },
        {
            "Name": "Sivasankar R",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2022",
            "AreasofResearch": "Metric Fixed Point Theory",
            "GuideName": "Dr. S. Rajesh",
            "GuideLink": "/dr-s-rajesh",
            "Email": "ma22d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/Sivasankar R.jpg"
        },
        {
            "Name": "Shivshankar Chandrakant Nila",
            "Position": "Ph.D Scholar",
            "Batch": "July 2021",
            "AreasofResearch": "Statistical Finance",
            "GuideName": "Dr. Ananya Lahiri",
            "GuideLink": "/dr-ananya-lahiri",
            "Email": "ma21d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/chandrakanth.jpg"
        },
        {
            "Name": "Debanjan Ghosh",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "TBD",
            "GuideName": "TBD",
            "GuideLink": "#",
            "Email": "ma20d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/debanjan.png"
        },
        {
            "Name": "Harsha Gopalakrishnan",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "Fractals",
            "GuideName": "Dr. Srijanani Anurag Prasad",
            "GuideLink": "/dr-srijanani-anurag-prasad",
            "Email": "ma20d503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/Harsha.jpg"
        },
        {
            "Name": "Gantasala Nagavyshnavi",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2020",
            "AreasofResearch": "Quantitative Finance",
            "GuideName": "Dr. Ananya Lahiri",
            "GuideLink": "/dr-ananya-lahiri",
            "Email": "ma20d002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/vyshnavi.jpg"
        },
        {
            "Name": "Abhishek",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2020",
            "AreasofResearch": "Fixed Point Theory",
            "GuideName": "Dr. S.Rajesh",
            "GuideLink": "/dr-s-rajesh",
            "Email": "ma20d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/abhishek.jpg"
        },
        {
            "Name": "Avhad Ganesh Vishnu",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "Statistical Finance",
            "GuideName": "Dr. Ananya Lahiri",
            "GuideLink": "/dr-ananya-lahiri",
            "Email": "ma20d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/ganesh.jpg"
        },
        {
            "Name": "Priyanka",
            "Position": "Ph.D Scholar",
            "Batch": "July 2020",
            "AreasofResearch": "TBD",
            "GuideName": "Dr. Panchatcharam M",
            "GuideLink": "/dr-panchatcharam-mariappan",
            "Email": "ma20d504@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/priyanka.jpg"
        },
        {
            "Name": "Debjoy Thakur",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Spatial Statistics",
            "GuideName": "Dr. Ishapathik Das",
            "GuideLink": "/dr-ishapathik-das",
            "Email": "ma19d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/debjoy.jpg"
        },
        {
            "Name": "Gangadhara B",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Microwave ablation solver using vector finite element method",
            "GuideName": "Dr. panchatcharam Mariappan",
            "GuideLink": "/dr-panchatcharam-mariappan",
            "Email": "ma19d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/gangadhar.jpg"
        },
        {
            "Name": "Megala",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2019",
            "AreasofResearch": "Fractals",
            "GuideName": "Dr. Srijanani Anurag Prasad",
            "GuideLink": "/dr-srijanani-anurag-prasad",
            "Email": "ma19d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/megala.jpg"
        },
        {
            "Name": "Sumangal Bhattacharya",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2019",
            "AreasofResearch": "Multivariate Response Models",
            "GuideName": "Dr. Ishapathik Das",
            "GuideLink": "/dr-ishapathik-das",
            "Email": "ma19d003@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/sumangal.jpg"
        },
        {
            "Name": "Snehil Srivastava",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2019",
            "AreasofResearch": "Lattice Boltzman Methods for Hyperbolic PDE's",
            "GuideName": "Dr. Panchatcharam Mariappan",
            "GuideLink": "/dr-panchatcharam-mariappan",
            "Email": "ma19d002@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/ma/snehil.jpg"
        },
        {
            "Name": "Divya G",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Inverse problems",
            "GuideName": "Dr. Durga Prasad Challa",
            "GuideLink": "/dr-durga-prasad-challa",
            "Email": "ma18d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/MA18D501_DIVYAG.jpg"
        },
        {
            "Name": "Rashmi Malik",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Fixed Point Theory",
            "GuideName": "Dr. S.Rajesh",
            "GuideLink": "/dr-s-rajesh",
            "Email": "ma18d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/ma18d502_RashmiMalik.jpg"
        },
        {
            "Name": "Suryanarayana Murty Ponnada",
            "Position": "Ph.D Scholar",
            "Batch": "July 2018",
            "AreasofResearch": "Inverse Problems",
            "GuideName": "Dr. Durga Prasad Challa",
            "GuideLink": "/dr-durga-prasad-challa",
            "Email": "ma18d503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/images/demo/iit/researchscholars/MA18D503_PSNMurty.jpg"
        }    

]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Mathematics and Statistics" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Mathematics and Statistics</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                           <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main